import React, { useState, useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from '../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';

function List(props) {
  const { entities, ids, setIds, multiSelect } = props;

  // Table columns
  const columns = [
    {
      dataField: 'icon',
      text: 'Зураг',
      sort: false,
      style: {
        width: '65px',
      },
      formatter: columnFormatters.IconColumnFormatter,
    },
    /*     {
      dataField: 'productCode',
      text: 'Код',
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.IdColumnFormatter,
    }, */
    {
      dataField: 'name',
      text: 'Нэр',
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.NameColumnFormatter,
    },
    {
      dataField: 'categoryName',
      text: 'Ангилал',
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: 'brandName',
      text: 'Брэнд',
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: 'typeCode',
      text: 'Төрөл',
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.TypeColumnFormatter,
    },
    {
      dataField: 'price',
      text: 'Үнэ',
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
    },
    {
      dataField: 'count',
      text: 'Үлдэгдэл',
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.CountColumnFormatter,
    },
  ];

  return (
    <>
      <BootstrapTable
        wrapperClasses='table-responsive'
        classes='table table-head-custom table-vertical-center overflow-hidden'
        size='xl'
        bootstrap4
        bordered={true}
        remote
        keyField='productCode'
        data={entities === null ? [] : entities}
        columns={columns}
        //onTableChange={getHandlerTableChange(setQueryParams)}
        selectRow={getSelectRow({
          entities,
          ids,
          setIds,
          multiSelect,
        })}
      >
        <PleaseWaitMessage entities={entities} />
        <NoRecordsFoundMessage entities={entities} />
      </BootstrapTable>
    </>
  );
}

export default List;
